<template>
  <AppLayout>

    <Head title="Tablice Kanban" />
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center flex-wrap gap-2">
              <h4 class="me-3 my-0">Tablice Kanban</h4>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="row mb-4">
            <div class="col-12 col-xl-6">
              <div class="card">
                <div class="card-header d-flex align-items-center justify-content-between">
                  <h5 class="mb-0">Utwórz tablicę</h5>
                  <button type="button"
                    class="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
                    style="width: 36px; height: 36px; padding: 0;" :aria-expanded="showCreateForm"
                    aria-label="Rozwiń lub zwiń formularz tworzenia tablicy" @click="showCreateForm = !showCreateForm">
                    <i :class="showCreateForm ? 'bi bi-dash-lg' : 'bi bi-plus-lg'"></i>
                  </button>
                </div>
                <transition name="board-collapse">
                  <div v-if="showCreateForm" class="card-body">
                    <form @submit.prevent="createBoard">
                      <div class="mb-3">
                        <label for="board-name" class="form-label">
                          Nazwa tablicy
                        </label>
                        <input id="board-name" v-model="form.name" type="text" class="form-control"
                          :class="{ 'is-invalid': form.errors.name }" maxlength="150" required />

                        <div v-if="form.errors.name" class="invalid-feedback">
                          {{ form.errors.name }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <label for="board-description" class="form-label">
                          Opis (opcjonalnie)
                        </label>
                        <textarea id="board-description" v-model="form.description" class="form-control"
                          :class="{ 'is-invalid': form.errors.description }" rows="3"></textarea>
                        <div v-if="form.errors.description" class="invalid-feedback d-block">
                          {{ form.errors.description }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <label for="board-visibility" class="form-label">
                          Widoczność
                        </label>
                        <select id="board-visibility" v-model="form.visibility" class="form-select"
                          :class="{ 'is-invalid': form.errors.visibility }">
                          <option value="private">Prywatna</option>
                          <option value="shared">Współdzielona</option>
                        </select>
                        <div v-if="form.errors.visibility" class="invalid-feedback">
                          {{ form.errors.visibility }}
                        </div>
                      </div>
                      <div v-if="isAdmin" class="mb-3">
                        <label for="board-department" class="form-label">
                          Przypisana do działu
                        </label>

                        <select id="board-department" v-model="form.department_id" class="form-select"
                          :class="{ 'is-invalid': form.errors.department_id }">
                          <option :value="null">Bez przypisanego działu</option>
                          <option v-for="department in departamenty" :key="department.id" :value="department.id">
                            {{ department.name }}
                          </option>
                        </select>
                        <div v-if="form.errors.department_id" class="invalid-feedback">
                          {{ form.errors.department_id }}
                        </div>
                      </div>
                      <button type="submit" class="btn btn-primary" :disabled="form.processing">
                        <i :class="form.processing ? 'bi bi-arrow-repeat me-2' : 'bi bi-plus-circle me-2'"></i>
                        {{ form.processing ? 'Tworzenie...' : 'Utwórz tablicę' }}
                      </button>
                    </form>
                  </div>
                </transition>
              </div>
            </div>
          </div>

          <div v-if="editingBoardId !== null" class="row mb-4">
            <div class="col-12 col-xl-6">
              <div class="card border-primary">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">Edytuj tablicę</h5>
                  <button type="button" class="btn-close" aria-label="Anuluj edycję" @click="cancelEdit"></button>
                </div>
                <div class="card-body">
                  <form @submit.prevent="updateBoard">
                    <div class="mb-3">
                      <label for="edit-board-name" class="form-label">
                        Nazwa tablicy
                      </label>
                      <input id="edit-board-name" v-model="editForm.name" type="text" class="form-control"
                        :class="{ 'is-invalid': editForm.errors.name }" maxlength="150" required />
                      <div v-if="editForm.errors.name" class="invalid-feedback">
                        {{ editForm.errors.name }}
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="edit-board-description" class="form-label">
                        Opis
                      </label>
                      <textarea id="edit-board-description" v-model="editForm.description" class="form-control"
                        :class="{ 'is-invalid': editForm.errors.description }" rows="3"></textarea>
                      <div v-if="editForm.errors.description" class="invalid-feedback">
                        {{ editForm.errors.description }}
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="edit-board-visibility" class="form-label">
                        Widoczność
                      </label>
                      <select id="edit-board-visibility" v-model="editForm.visibility" class="form-select"
                        :class="{ 'is-invalid': editForm.errors.visibility }" required>
                        <option value="private">Prywatna</option>
                        <option value="shared">Współdzielona</option>
                      </select>
                      <div v-if="editForm.errors.visibility" class="invalid-feedback">
                        {{ editForm.errors.visibility }}
                      </div>
                    </div>
                    <div  v-if="isAdmin" class="mb-3">
                      <label for="edit-board-department" class="form-label">
                        Przypisana do działu
                      </label>
                      <select id="edit-board-department" v-model="editForm.department_id" class="form-select"
                        :class="{ 'is-invalid': editForm.errors.department_id }">
                        <option :value="null">Bez przypisanego działu</option>
                        <option v-for="department in departamenty" :key="department.id" :value="department.id">
                          {{ department.name }}
                        </option>
                      </select>
                      <div v-if="editForm.errors.department_id" class="invalid-feedback">
                        {{ editForm.errors.department_id }}
                      </div>
                    </div>
                    <button type="submit" class="btn btn-primary me-2" :disabled="editForm.processing">
                      <i class="bi bi-check-circle me-1"></i>
                      {{ editForm.processing ? 'Zapisywanie...' : 'Zapisz zmiany' }}
                    </button>
                    <button type="button" class="btn btn-outline-secondary" :disabled="editForm.processing"
                      @click="cancelEdit">
                      Anuluj
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h5 class="mb-0">Twoje tablice</h5>
                <span class="badge bg-secondary">
                  {{ boards.length }}
                </span>
              </div>
              <div v-if="boards.length === 0" class="alert alert-light border" role="status">
                <i class="bi bi-kanban me-2"></i>
                Nie masz jeszcze żadnych tablic. Utwórz pierwszą powyżej.
              </div>
              <div v-else class="custom-table">
                <div class="table-responsive">
                  <table class="table table-hover align-middle">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Nazwa tablicy</th>
                        <th>Opis</th>
                        <th>Zadania</th>
                        <th>Widoczność</th>
                        <th>Akcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(board, index) in boards" :key="board.id">
                        <td>{{ index + 1 }}</td>
                        <td>
                          <span class="fw-semibold">
                            {{ board.name }}
                          </span>
                        </td>
                        <td>
                          <span class="text-muted">
                            {{ board.description || 'Brak opisu' }}
                          </span>
                        </td>
                        <td>
                          <span class="badge bg-light text-dark">
                            {{ board.cards_count }}
                          </span>
                        </td>
                        <td>
                          <span class="badge" :class="board.visibility === 'shared' ? 'bg-info' : 'bg-secondary'">
                            {{
                              board.visibility === 'shared'
                                ? 'Współdzielona'
                                : 'Prywatna'
                            }}
                          </span>
                        </td>

                        <td>
                          <Link :href="`/kanban/boards-all/${board.id}`" class="btn btn-sm btn-outline-primary me-1">
                          <i class="bi bi-kanban me-1"></i>
                          Otwórz
                          </Link>
                          <button  v-if="canEditBoard(board)" type="button" class="btn btn-sm btn-outline-secondary" @click="editBoard(board)">
                            <i class="bi bi-pencil me-1"></i>
                            Edytuj
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>


<script>
import AppLayout from '@/Layouts/App.vue'
import { Head, Link, useForm } from '@inertiajs/vue3'
import { usePermission } from '@/composables/resources/js/composables/permissions.js'

const { hasRole, hasPermission } = usePermission()

export default {
  components: {
    AppLayout,
    Head,
    Link,
  },
  props: {
    boards: {
      type: Array,
      default: () => [],
    },
    departamenty: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      editingBoardId: null,
      showCreateForm: false,
	  hasPermission,
      hasRole,
      form: useForm({
        name: '',
        description: '',
        visibility: 'private',
        department_id: null,
      }),

      editForm: useForm({
        name: '',
        description: '',
        visibility: 'private',
        department_id: null,
      }),
    }
  },

  methods: {
  canEditBoard(board) {
  return this.isAdmin() || Number(board.created_by) === Number(this.$page.props.auth.user.id)
},
      isAdmin() {
      return hasRole('ADMIN');
    },
    createBoard() {
      this.form.post('/kanban/boards/store', {
        preserveScroll: true,

        onSuccess: () => {
          this.form.reset()
          this.form.clearErrors()
        },
      })
    },

    editBoard(board) {
      this.editingBoardId = board.id

      this.editForm.clearErrors()

      this.editForm.name = board.name ?? ''
      this.editForm.description = board.description ?? ''
      this.editForm.visibility = board.visibility ?? 'private'
      this.editForm.department_id =
        board.department_id == null || board.department_id === ''
          ? null
          : Number(board.department_id)
    },

    updateBoard() {
      if (this.editingBoardId === null) {
        return
      }

      this.editForm.put(`/kanban/boards/update/${this.editingBoardId}`, {
        preserveScroll: true,

        onSuccess: () => {
          this.cancelEdit()
        },
      })
    },

    cancelEdit() {
      this.editingBoardId = null
      this.editForm.reset()
      this.editForm.clearErrors()
    },
  },
}
</script>
<style scoped>
.board-collapse-enter-active,
.board-collapse-leave-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
  transform-origin: top;
}

.board-collapse-enter-from,
.board-collapse-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>